import * as React from 'react';
import { DropDownListComponent } from '../DropDownList/DropDownListComponent';
import { ItemList } from '../../types/logbook-type';
import { useLanguageLocale } from '../../hooks/language-locale-hooks';
import { ticketStatus } from '../../app/enum/ENUM';

export interface Props {
    defaultValue: string;
    callback: (ticketStatusValue: number) => void;
}

const MaintenanceTicketStatusFilterSelect: React.FunctionComponent<Props> = (props) => {

    const { defaultValue, callback } = props;
    
    const { t } = useLanguageLocale();

    const [data] = React.useState<ItemList>(ticketStatus);

    const handleChange = (ticketStatusValue: number) => {
        callback(ticketStatusValue);
    }

    return (
        <DropDownListComponent
            disabled={false}
            data-testid="asset-maintenance-ticket-status-filter"
            list={data}
            value={t('SEARCH.ALL_STATUSES')}
            handleSelection={handleChange}
            selected={''}
            defaultSelection={defaultValue}>
        </DropDownListComponent>
    );
};

export default MaintenanceTicketStatusFilterSelect;
